import React, { PureComponent } from "react";

import { timeFormat } from "d3-time-format";

var formatDate = timeFormat("%e.%m %H:%M")

const Tooltips = class extends PureComponent {
  render() {
    let { 
      xScale, 
      yScale, 
      mouseX,
      height,
        values,
        sensorKeys,
        colorsForSensors
    } = this.props;

    if (mouseX < xScale.range()[0] || mouseX > xScale.range()[1]) {
      return null
    }
    const mouseTime = xScale.invert(mouseX).getTime() 

    const toolTips = sensorKeys.map((sensorKey)=>{
      let vals = values[sensorKey]
      let index = vals.length-1

      if (vals.length === 0 || !vals[0]) {
        return undefined
      }

      if (mouseTime <= new Date(vals[0].date).getTime()) {
        index = 0
        
      }else{
        for (let i = 0; i < vals.length; i++) {
            const x1 = vals[i];
            const t1 = new Date(x1.date).getTime();
      
            if (t1 > mouseTime) {
                const x0 = vals[i-1];
                if (!x0) {
                  break;
                }
                const t0 = new Date(x0.date).getTime();
                if (Math.abs(t1-mouseTime) > Math.abs(t0-mouseTime)) {
                  index = i-1
                } else {
                  index = i
                }              
                break;
            } 

        }
      }

      const resolvedElement = vals[index]
      if (!resolvedElement) {
        resolvedElement = vals[0]
      }
      const resolvedDate = new Date(resolvedElement.date)
      const resolvedX = xScale(resolvedDate)
      const resolvedY = yScale(resolvedElement.value)
      const displayValue = parseFloat(resolvedElement.value).toFixed(2)
      const displayDate = formatDate(resolvedDate)
      return {
        resolvedX,
        resolvedY,
        displayValue,
        displayDate,
        color: colorsForSensors[sensorKey]
      }
    })



    const range = yScale.range()
    const hh = 32
    return (
      <g>
      {toolTips.map(params=>{
        if (!params) {
          return null
        }
      return (
        <>
        {/* <line x1={mouseX} y1={range[0]} x2={mouseX} y2={range[1]} stroke="lightgray"></line> */}
        <circle
        fill={params.color}
        cx={params.resolvedX}
        cy={params.resolvedY}
        r={5}
        />

       </>
      )
    })}       
    <svg x={mouseX-50} y={toolTips[0].resolvedY + 10} style={{"overflow": "visible"}}>
      <rect width="100" height={hh*toolTips.length} stroke="lightgrey" strokeWidth="4" ></rect>

      {
        toolTips.map((params, i)=>{
          if (!params) {
            return null
          }
          return(
            <g >
              <rect y={i*hh - (i*0.5)} width="100" height={hh} fill="white"></rect>
              <text  x="50"  y={i*hh + 4} dominantBaseline="hanging" textAnchor="middle" fontSize="14" fill={params.color}>{params.displayDate}</text>
              <text  x="50"  y={i*hh + 18} dominantBaseline="hanging" textAnchor="middle" fontSize="14" fontWeight="bold" fill={params.color}>{params.displayValue}</text>
            </g>
          )
        })
      }

    </svg>
    </g>
    
    )
  }
};

export default Tooltips;
